import { Guid, Nillable } from '@web/utils';
import { jsonMember, jsonObject } from 'typedjson';
import { AdminCosmeticContextOperationsResponse } from './admin-cosmetic-context-operations.response';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminCosmeticBrandResponse } from './admin-cosmetic-brand.response';
import { AdminCosmeticStatus } from '../../enums/admin-cosmetic-status';

@jsonObject
export class AdminCosmeticCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Number)
  public readonly price?: Nillable<number>;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly status!: AdminCosmeticStatus;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(AdminCosmeticBrandResponse)
  public readonly cosmeticBrand?: Nillable<AdminCosmeticBrandResponse>;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(AdminCosmeticContextOperationsResponse)
  public readonly contextOperations!: AdminCosmeticContextOperationsResponse;
}
